import { render, staticRenderFns } from "./DashboardConversations.vue?vue&type=template&id=239b3356&lang=pug"
import script from "./DashboardConversations.vue?vue&type=script&lang=js"
export * from "./DashboardConversations.vue?vue&type=script&lang=js"
import style0 from "./DashboardConversations.vue?vue&type=style&index=0&id=239b3356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports